import styled from 'styled-components';
import { MediaQueryMobileOnly } from '../utils/constants';

export const ResponsiveFlex = styled.div`
display: flex;
align-items: stretch;

${MediaQueryMobileOnly} {
  flex-direction: column;
}
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const VFlex = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const Center = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
